module.exports = __webpack_public_path__ + "static/media/documents_cles_PCO.4ea21eaa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/common/documents_cles_PCO.pdf
// module id = 309
// module chunks = 40